import { Injectable } from '@angular/core';
import _ from 'lodash';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { CommonQuestionModel } from '../models';
import { CommonQuestionsService } from './common-questions.service';
@Injectable()
export class QuestionsStoreService {
  private readonly _storeSub = new BehaviorSubject<CommonQuestionModel[]>([]);
  visitKey: string;
  questionsStore$ = this._storeSub.asObservable();
  /**
   *
   */
  constructor(private questionsService: CommonQuestionsService) {}

  async initStore(key: string) {
    this.visitKey = key;
    const result = await lastValueFrom(
      this.questionsService.getQuestions({ 'visitKey.equals': key })
    );

    if (result) {
      this._storeSub.next(result);
    }
  }

  pushToStore(question: CommonQuestionModel) {
    const _values = this._storeSub.getValue();
    _values.push(question);
    this._storeSub.next(_values);
  }

  removeFromStore(id: number) {
    const _values = this._storeSub.getValue();
    const _data = _values.filter((itm) => itm?.id !== id);
    this._storeSub.next(_data);
  }

  updateItem(question: CommonQuestionModel) {
    const _values = this._storeSub.getValue();
    const index = _values.findIndex((itm) => itm.id === question?.id);
    if (index >= 0) {
      _values[index] = question;
    }
    this._storeSub.next(_.cloneDeep(_values));
  }

  refreshStore() {
    this.initStore(this.visitKey);
  }
}
